import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Heart, 
  LayoutDashboard, 
  Users, 
  Calendar,
  Settings, 
  LogOut 
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import "./DoctorSidebar.css";

const DoctorSidebar = () => {
  const { logout } = useAuth();
  const location = useLocation();

  const navLinks = [
    { path: "/dashboard/doctor", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/dashboard/doctor/patients", icon: Users, label: "Patients" },
    { path: "/dashboard/doctor/appointments", icon: Calendar, label: "Appointments" },
    { path: "/dashboard/doctor/settings", icon: Settings, label: "Settings" }
  ];

  return (
    <aside className="doctor-sidebar">
      <div className="sidebar-brand">
        <div className="brand-logo">
          <Heart size={20} fill="currentColor" />
        </div>
        <div className="brand-info">
          <span className="brand-name">Medico.in</span>
          <span className="brand-tag">Healthcare Monitoring</span>
        </div>
      </div>

      <div className="sidebar-section-label">Doctor Portal</div>
      <nav className="sidebar-nav">
        {navLinks.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.path;
          return (
            <Link 
              key={link.label} 
              to={link.path} 
              className={`nav-item ${isActive ? "active" : ""}`}
            >
              <Icon size={20} />
              <span>{link.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={logout} style={{ background: 'none', border: 'none', width: '100%', cursor: 'pointer', textAlign: 'left' }}>
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default DoctorSidebar;
